import React from 'react';
import styled from 'styled-components';
import { pretendardFont } from '../../styles/typography';
import airFranceLogo from '../../assets/icons/partners/air-france.png';
import beroccaLogo from '../../assets/icons/partners/berocca.png';
import bottegaVenetaLogo from '../../assets/icons/partners/bottega-veneta.png';
import coachLogo from '../../assets/icons/partners/coach.png';
import eclipseLogo from '../../assets/icons/partners/eclipse.png';
import hiltonLogo from '../../assets/icons/partners/hilton.png';
import kinderJoyLogo from '../../assets/icons/partners/kinder-joy.png';
import kozelLogo from '../../assets/icons/partners/kozel.png';
import lexusLogo from '../../assets/icons/partners/lexus.png';
import matinKimLogo from '../../assets/icons/partners/matin-kim.png';
import mmsLogo from '../../assets/icons/partners/mms.png';
import nexonLogo from '../../assets/icons/partners/nexon.png';
import pernodRicardLogo from '../../assets/icons/partners/pernod-ricard.png';
import ps5Logo from '../../assets/icons/partners/ps5.png';
import seoulMySoulLogo from '../../assets/icons/partners/seoul-my-soul.png';
import snickersLogo from '../../assets/icons/partners/snickers.png';
import uniqloLogo from '../../assets/icons/partners/uniqlo.png';
import vietjetAirLogo from '../../assets/icons/partners/vietjet-air.png';
import { Reveal, Section, SectionInner } from '../section/common';
import { useScrollReveal } from '../../hooks/useScrollReveal';

const PARTNER_LOGOS = [
  { name: 'Air France', src: airFranceLogo },
  { name: 'Berocca', src: beroccaLogo },
  { name: 'Bottega Veneta', src: bottegaVenetaLogo },
  { name: 'Coach', src: coachLogo },
  { name: 'Eclipse', src: eclipseLogo },
  { name: 'Hilton', src: hiltonLogo },
  { name: 'Kinder Joy', src: kinderJoyLogo },
  { name: 'Kozel', src: kozelLogo },
  { name: 'Lexus', src: lexusLogo },
  { name: 'Matin Kim', src: matinKimLogo },
  { name: "M&M's", src: mmsLogo },
  { name: 'Nexon', src: nexonLogo },
  { name: 'Pernod Ricard', src: pernodRicardLogo },
  { name: 'PS5', src: ps5Logo },
  { name: 'Seoul My Soul', src: seoulMySoulLogo },
  { name: 'Snickers', src: snickersLogo },
  { name: 'Uniqlo', src: uniqloLogo },
  { name: 'Vietjet Air', src: vietjetAirLogo },
];

const PartnersWrapper = styled(Section)`
  padding: 120px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 80px 0;
  }
`;

const Title = styled.h2`
  ${pretendardFont}
  text-align: center;
  font-size: 40px;
  font-weight: 700;
  letter-spacing: -1px;
  color: #111111;
  margin-bottom: 60px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 28px;
    margin-bottom: 32px;
  }
`;

const LogoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 24px;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }
`;

const LogoItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 72px;
    object-fit: contain;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
      height: 42px;
    }
  }
`;

const PartnersSection: React.FC = () => {
  const { ref, isVisible } = useScrollReveal();

  return (
    <PartnersWrapper>
      <SectionInner ref={ref}>
        <Reveal $visible={isVisible}>
          <Title>Our Partners</Title>
          <LogoGrid>
            {PARTNER_LOGOS.map((partner) => (
              <LogoItem key={partner.name}>
                <img src={partner.src} alt={partner.name} loading="lazy" />
              </LogoItem>
            ))}
          </LogoGrid>
        </Reveal>
      </SectionInner>
    </PartnersWrapper>
  );
};

export default PartnersSection;
